export const LANGUAGES = {
  DA_DK: 'da_dk',
  DE: 'de',
  EL_GR: 'el_gr',
  EN_GB: 'en_gb',
  EN_US: 'en_us',
  ES: 'es',
  ET_EE: 'et_ee',
  FI_FI: 'fi_fi',
  FR: 'fr',
  HR_HR: 'hr_hr',
  IT: 'it',
  JA_JP: 'ja_jp',
  LT_LT: 'lt_lt',
  LV_LV: 'lv_lv',
  NL: 'nl',
  NO: 'no',
  PL: 'pl',
  PT: 'pt',
  RO_RO: 'ro_ro',
  RU: 'ru',
  SV: 'sv',
  UK: 'uk',
  BS_BA: 'bs_ba',
  BG_BG: 'bg_bg',
  HU_HU: 'hu_hu',
  KO_KR: 'ko_kr',
  MS_MY: 'ms_my',
  SR_RS: 'sr_rs',
  ZH_CN: 'zh_cn',
  ZH_HK: 'zh_hk',
  ZH_TW: 'zh_tw',
  FIL_PH: 'fil_ph',

};

export const ALL_LANGUAGES = Object.values(LANGUAGES);

export const DEFAULT_LANGUAGE = LANGUAGES.EN_US;

const OVERRIDDEN_ISO_LOCALES = {
  no: 'nb-NO',
  sv: 'sv-SE',
  uk: 'uk-UA',
};

/**
 * @param {string} locale
 * @returns {{ country: string, language: string }}
 */
export const getLocaleDetails = locale => {
  const regexp = /^(?<country>[a-z]{2})((?<divider>_|-)(?<language>[a-z]+))?$/i;
  const matches = (OVERRIDDEN_ISO_LOCALES[locale] ?? locale)?.match(regexp);

  if (matches) {
    const [, country,,, language] = matches;
    return {
      country: country.toLowerCase(),
      language: (language ?? country).toUpperCase(),
    };
  }
  return getLocaleDetails(DEFAULT_LANGUAGE);
};

/**
 * @param {string} locale
 * @param {string} divider
 * @returns {string}
 * @example
 *    getISOLocale('en-US') // 'en-US'
 *    getISOLocale('fr') // 'fr-FR'
 */
export const getLocaleUsage = (locale) => {
  const { country, language } = getLocaleDetails(locale);
  return `${country.toLowerCase()}-${language.toUpperCase()}`;
};
